import { until } from 'until-async'
import type { SDK } from 'ysdk'
import { Deferred, deferred } from '../../robowhale/utils/async/deferred'
import { getErrorLog } from '../../robowhale/utils/error/utils'
import { Platform } from '../Platform'
import { BasePlatformPreloader } from './BasePlatformPreloader'

export class YaPlatformPreloader extends BasePlatformPreloader {
	public readonly type: Platform = 'yandex'
	private _initCompleted: Deferred<SDK> | undefined

	public async loadAndInit(): Promise<SDK> {
		if (this._initCompleted) {
			return this._initCompleted
		}

		this._initCompleted = deferred<SDK>()

		// проверяем, не была ли загружена sdk ранее самим yandex
		const wasSdkLoaded = Boolean(window['YaGames'])
		if (!wasSdkLoaded) {
			await this.loadScriptWithRetries('/sdk.js')
		}

		if (!YaGames) {
			throw new Error(`SDK script was loaded but 'YaGames' is not available`)
		}

		const [error, sdk] = await until(() => YaGames.init())
		if (error) {
			throw new Error(getErrorLog(error))
		}
		
		// expose initialized Yandex SDK for convenience
		window.ysdk = sdk

		this._initCompleted.resolve(sdk)

		return this._initCompleted
	}
}
